/**
 * SmartyLogo — isotipo de marca (hexágono con "S" en negativo).
 *
 * FUENTE ÚNICA del logo de Smarty en la app. Reconstrucción vectorial del
 * isotipo (escala sin pixelarse: header 24px, favicon, PWA 512px, PDF).
 * El mismo path vive en `public/smarty-icon.svg` (favicon/PWA/push) — si se
 * ajusta la forma, actualizar ambos.
 *
 * `color` controla el relleno (default `currentColor` → hereda el color del
 * contenedor; en el TopBar oscuro se pasa "#fff").
 */

/** Path del isotipo en un viewBox 0 0 512 512, centrado. */
export const SMARTY_MARK_PATH =
  'M256 83 L406 169.5 L406 181 L201 181 L201 231 L406 231 L406 342.5 L256 429 ' +
  'L106 342.5 L106 331 L311 331 L311 281 L106 281 L106 169.5 Z';

interface SmartyLogoProps {
  /** Alto en px (el ancho se calcula manteniendo proporción). */
  size?: number;
  /** Color del relleno. Default `currentColor`. */
  color?: string;
  className?: string;
  title?: string;
}

// viewBox recortado al bounding box real del isotipo (con margen para el stroke
// de 10px). Antes usaba "0 0 512 512" con mucho espacio transparente + `width="auto"`
// (inválido como atributo SVG → el navegador le daba ~300px de ancho, empujando
// el wordmark). Ahora el box va justo al dibujo y el ancho es explícito.
const MARK_VIEWBOX = '98 75 316 362';
const MARK_ASPECT = 316 / 362; // ancho / alto

export function SmartyLogo({ size = 24, color = 'currentColor', className, title }: SmartyLogoProps) {
  return (
    <svg
      viewBox={MARK_VIEWBOX}
      height={size}
      width={Math.round(size * MARK_ASPECT)}
      fill="none"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      className={className}
      style={{ flexShrink: 0, display: 'block' }}
    >
      {title && <title>{title}</title>}
      <path
        d={SMARTY_MARK_PATH}
        fill={color}
        stroke={color}
        strokeWidth={10}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SmartyLogo;
